import { Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import {
  NewTag,
  TagsContainer,
} from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/radio-group/radio-group.style'
import { RADIO_OPTIONS } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/radio-group/radio-group.utils'
import { RosterTag } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/roster-tag/roster-tag'
import { useMemo } from 'react'
import { connect, FormikProps } from 'formik'
import {
  IAcceptanceCriteriaFormValues,
  ACCEPTANCE_CRITERIA_OPTION,
} from '@src/features/shift-post-v2/steps/acceptance-criteria-step/acceptance-criteria-step.types'
import { getSelectedAcceptanceCriteriaOption } from '@src/features/shift-post-v2/utils'
import { BoldSpan } from '@src/components/common/style'
import { SummaryContainer } from './summary.style'

interface ISummaryProps {
  formik?: FormikProps<IAcceptanceCriteriaFormValues>
}

export const Summary = connect<ISummaryProps>(({ formik }) => {
  const { errors, values } = formik

  const selectedRosters = values.auto_accept_rosters

  const selectedAcceptanceCriteriaOption = useMemo(
    () =>
      getSelectedAcceptanceCriteriaOption(
        values.auto_accept_by_rosters,
        values.auto_accept,
      ),
    [values.auto_accept_by_rosters, values.auto_accept],
  )

  const title = useMemo(() => {
    return RADIO_OPTIONS.find(
      option => option.value === selectedAcceptanceCriteriaOption,
    )?.title
  }, [selectedAcceptanceCriteriaOption])

  const description = useMemo(() => {
    return RADIO_OPTIONS.find(
      option => option.value === selectedAcceptanceCriteriaOption,
    )?.description
  }, [selectedAcceptanceCriteriaOption])

  const rosterPickerErrorMessage = useMemo(() => {
    if (
      errors.auto_accept_rosters &&
      typeof errors.auto_accept_rosters === 'string'
    ) {
      return errors.auto_accept_rosters
    }
    return null
  }, [errors.auto_accept_rosters])

  return (
    <SummaryContainer>
      <Flex alignItems="center">
        <Text fontSize="medium" mt={0} mb="xs" fontWeight="semiBold">
          {title}
        </Text>

        {selectedAcceptanceCriteriaOption ===
          ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS && (
          <NewTag type="plum_500" size="small" ml="xs">
            NEW
          </NewTag>
        )}
      </Flex>

      <Text fontSize="small" color="gray" my={0}>
        {description}
        {selectedAcceptanceCriteriaOption ===
          ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS && (
          <BoldSpan>
            &nbsp;The selected rosters will be automatically invited.
          </BoldSpan>
        )}
      </Text>

      {selectedAcceptanceCriteriaOption ===
        ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS &&
        rosterPickerErrorMessage && (
          <Text color="danger" fontSize="small" mt="xs" mb={0}>
            {rosterPickerErrorMessage}
          </Text>
        )}

      {selectedAcceptanceCriteriaOption ===
        ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS &&
        !rosterPickerErrorMessage && (
          <>
            <TagsContainer>
              {selectedRosters.length > 0 ? (
                <>
                  {/* Selected Roster Tags */}
                  {selectedRosters.map(item => (
                    <RosterTag
                      key={item.id}
                      value={item.id}
                      label={item.name}
                      handleRemoveTag={() => {}}
                      isClosable={false}
                    />
                  ))}
                </>
              ) : null}
            </TagsContainer>
          </>
        )}
    </SummaryContainer>
  )
})
